/* © CNES */
import { Coordinate } from 'ol/coordinate';
/**
 * GeoServer Polygon.
 */
export class GeoJsonPolygon {
  type: string = 'FeatureCollection';
  features = [
    {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [] as Coordinate[][],
      },
    },
  ];
}
